module.exports = __webpack_public_path__ + "static/img/8.aa39587.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/8.png
// module id = p9Y3
// module chunks = 0